import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { UniversalCreatePublisherModalProps } from './UniversalCreatePublisherModal';

export const UniversalCreatePublisherModalLoader = (): Promise<typeof import('./UniversalCreatePublisherModal')> =>
  import(/* webpackChunkName: "4-feat-universal-create-publisher" */ './UniversalCreatePublisherModal');

const LoadableUniversalCreatePublisherModal: ComponentType<UniversalCreatePublisherModalProps> = lazyLoadOnRender({
  loader: UniversalCreatePublisherModalLoader,
});
export default LoadableUniversalCreatePublisherModal;
